import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { withRouter } from 'react-router-dom';
import SweetAlert from 'react-bootstrap-sweetalert';
import {
  DropdownItem, DropdownMenu, DropdownToggle, UncontrolledButtonDropdown,
} from 'reactstrap';

import Table from '../../../components/table/Table';
import ROUTES from '../../../config/routes';
import OutboundOrderHelpers from '../../../helpers/outboundOrder';
import ProductHelpers from '../../../helpers/products';
import FormatHelpers from '../../../helpers/format';
import WikiHelp from '../../../components/tooltip/wikiHelp';
import addNotification from '../../../components/notification';
import UserConfirmationModal from '../../../components/pages/userConfirmationModal';
import Permissions from '../../../app/services/permissions';

import {
  getSimplifiedLoadMonitorDocuments,
  getSimplifiedLoadMonitorProducts,
  generateOutboundOrderFromSimplifiedLoad,
  cancelSimplifiedLoadDocument,
  cancelSimplifiedLoadProduct,
} from '../../../app/store/actions/outboundOrderLoadSimplified';

class SimplifiedLoadMonitor extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      startDate: moment().subtract(30, 'd'),
      endDate: moment(),
      selectedOutboundOrder: {},
      defaultSortedProducts: [{
        id: 'lineNumber',
        desc: false,
      }],
      defaultSorted: [{
        id: 'orderNumber',
        desc: false,
      }],
      simplifiedOutboundOrdersList: [],
      simplifiedOutboundProductsList: [],
      simplifiedLoadChecked: {},
      simplifiedLoadAnchorLoadId: null,
      showGenerateSimplifiedLoadModal: false,
      showCancelDocumentModal: false,
      showCancelProductModal: false,
      showUserModal: false,
      cancelType: '',
      selectedSimplifiedProduct: null,
      tableColumns: [],
      productTableColumns: [],
    };
  }

  componentDidMount() {
    this.getOutboundOrders();
    this.updateColumns();
  }

  isSimplifiedLoadRowSelectable = (row) => {
    if (!row.outboundLoadId || row.loadGrouped) {
      return false;
    }
    const { simplifiedLoadAnchorLoadId } = this.state;
    if (!simplifiedLoadAnchorLoadId) {
      return true;
    }
    return simplifiedLoadAnchorLoadId === row.outboundLoadId;
  };

  singleSimplifiedLoadSelection = (row) => {
    if (!this.isSimplifiedLoadRowSelectable(row)) {
      return;
    }
    const { simplifiedLoadChecked, simplifiedLoadAnchorLoadId } = this.state;
    const nextChecked = { ...simplifiedLoadChecked };
    const isChecked = !!nextChecked[row.id];
    if (isChecked) {
      delete nextChecked[row.id];
    } else {
      nextChecked[row.id] = true;
    }
    const selectedIds = Object.keys(nextChecked);
    let nextAnchorLoadId = simplifiedLoadAnchorLoadId;
    if (!selectedIds.length) {
      nextAnchorLoadId = null;
    } else if (!nextAnchorLoadId) {
      nextAnchorLoadId = row.outboundLoadId;
    }
    this.setState({
      simplifiedLoadChecked: nextChecked,
      simplifiedLoadAnchorLoadId: nextAnchorLoadId,
    });
  };

  getSelectedSimplifiedLoadIds = () => {
    const { simplifiedLoadChecked } = this.state;
    return Object.keys(simplifiedLoadChecked).filter(
      (id) => simplifiedLoadChecked[id],
    ).map((id) => parseInt(id, 10));
  };

  getSelectedSimplifiedLoadRows = () => {
    const selectedIds = this.getSelectedSimplifiedLoadIds();
    const { simplifiedOutboundOrdersList } = this.state;
    return simplifiedOutboundOrdersList.filter(
      (row) => selectedIds.indexOf(row.id) !== -1,
    );
  };

  getPendingDocumentsCountForSelectedLoad = () => {
    const rows = this.getSelectedSimplifiedLoadRows();
    if (!rows.length) {
      return 0;
    }
    const row = rows[0];
    const linked = Number(row.linkedDocumentsCount);
    const expected = row.loadDocumentCount;
    if (
      expected === ''
      || expected === null
      || expected === undefined
    ) {
      return 0;
    }
    const expectedNum = Number(expected);
    if (Number.isNaN(linked) || Number.isNaN(expectedNum)) {
      return 0;
    }
    const pending = expectedNum - linked;
    return pending > 0 ? pending : 0;
  };

  hasPendingDocumentsForSelectedLoad = () => this.getPendingDocumentsCountForSelectedLoad() > 0;

  showGenerateSimplifiedLoadModal = () => {
    const selectedIds = this.getSelectedSimplifiedLoadIds();
    if (!selectedIds.length) {
      addNotification(
        'warning',
        I18n.t('BEE4865' /* Carregamento Simplificado */),
        I18n.t('BEE4874' /* Selecione ao menos um documento */),
        'top-right',
      );
      return;
    }
    if (this.hasPendingDocumentsForSelectedLoad()) {
      this.setState({ showGenerateSimplifiedLoadModal: true });
      return;
    }
    this.generateOutboundOrderFromSimplifiedLoad();
  };

  closeGenerateSimplifiedLoadModal = () => {
    this.setState({ showGenerateSimplifiedLoadModal: false });
  };

  generateOutboundOrderFromSimplifiedLoad = async () => {
    const selectedIds = this.getSelectedSimplifiedLoadIds();
    this.closeGenerateSimplifiedLoadModal();
    try {
      const result = await this.props.generateOutboundOrderFromSimplifiedLoad(
        selectedIds,
      );
      if (result && result.outboundOrderId) {
        addNotification(
          'success',
          I18n.t('BEE4865' /* Carregamento Simplificado */),
          I18n.t(
            'BEE4878',
            { 0: result.orderNumber } /* Documento %{0} gerado com sucesso */,
          ),
          'top-right',
        );
        this.setState({
          simplifiedLoadChecked: {},
          simplifiedLoadAnchorLoadId: null,
          selectedOutboundOrder: {},
          simplifiedOutboundProductsList: [],
        });
        await this.getOutboundOrders();
        return;
      }
      if (result && result.success === false && result.error && result.error.message) {
        addNotification(
          'danger',
          I18n.t('BEE4865' /* Carregamento Simplificado */),
          result.error.message,
          'top-right',
        );
      }
    } catch (err) {
      const error = err.response && err.response.data && err.response.data.error;
      const message = (error && error.message)
        ? error.message
        : I18n.t('BEE4873' /* Erro ao gerar documento agrupado */);
      addNotification(
        'danger',
        I18n.t('BEE4865' /* Carregamento Simplificado */),
        message,
        'top-right',
      );
    }
  };

  canCancelSimplifiedDocument = (row) => {
    if (!row || row.loadGrouped) {
      return false;
    }
    if (this.props.isConsult) {
      return false;
    }
    return row.status < 4;
  };

  canCancelSimplifiedProduct = (row) => {
    const { selectedOutboundOrder } = this.state;
    if (!row || !selectedOutboundOrder || selectedOutboundOrder.loadGrouped) {
      return false;
    }
    if (this.props.isConsult) {
      return false;
    }
    if (row.pickedQuantity && parseFloat(row.pickedQuantity) > 0) {
      return false;
    }
    return row.status > 0 && row.status <= 4;
  };

  showCancelDocument = (row) => {
    this.setState({
      showCancelDocumentModal: true,
      cancelType: 'document',
      selectedOutboundOrder: row,
    });
  };

  showCancelProduct = (row) => {
    this.setState({
      showCancelProductModal: true,
      cancelType: 'product',
      selectedSimplifiedProduct: row,
    });
  };

  userConfirmation = async (confirm) => {
    const { cancelType } = this.state;
    this.setState({ showUserModal: false });
    if (confirm && cancelType === 'document') this.cancelDocument();
    if (confirm && cancelType === 'product') this.cancelProduct();
  };

  notifyCancelError = (error, fallback) => {
    const responseError = error && error.response && error.response.data && error.response.data.error;
    const message = (responseError && responseError.message)
      ? responseError.message
      : fallback;
    addNotification(
      'danger',
      I18n.t('BEE4865' /* Carregamento Simplificado */),
      message,
      'top-right',
    );
  };

  cancelDocument = async () => {
    const { selectedOutboundOrder } = this.state;
    try {
      const result = await this.props.cancelSimplifiedLoadDocument(selectedOutboundOrder.id);
      if (result && result.success === false) {
        const message = result.error && result.error.message
          ? result.error.message
          : I18n.t('BEE2948' /* Erro ao cancelar Documento de Saída */);
        addNotification(
          'danger',
          I18n.t('BEE4865' /* Carregamento Simplificado */),
          message,
          'top-right',
        );
      } else {
        addNotification(
          'success',
          I18n.t('BEE4865' /* Carregamento Simplificado */),
          I18n.t('BEE2949' /* Documento cancelado com sucesso! */),
          'top-right',
        );
        await this.getOutboundOrders();
      }
    } catch (error) {
      this.notifyCancelError(
        error,
        I18n.t('BEE2950' /* Não foi possível cancelar o Documento de Saída. */),
      );
    }
    this.setState({ cancelType: '' });
  };

  cancelProduct = async () => {
    const { selectedSimplifiedProduct } = this.state;
    try {
      const result = await this.props.cancelSimplifiedLoadProduct(
        selectedSimplifiedProduct.id,
      );
      if (result && result.success === false) {
        const message = result.error && result.error.message
          ? result.error.message
          : I18n.t('BEE2952' /* Erro ao cancelar Produto */);
        addNotification(
          'danger',
          I18n.t('BEE4865' /* Carregamento Simplificado */),
          message,
          'top-right',
        );
      } else {
        addNotification(
          'success',
          I18n.t('BEE4865' /* Carregamento Simplificado */),
          I18n.t('BEE2953' /* Produto cancelado com sucesso! */),
          'top-right',
        );
        await this.getOutboundOrders();
      }
    } catch (error) {
      this.notifyCancelError(
        error,
        I18n.t('BEE2954' /* Não foi possível cancelar o Produto */),
      );
    }
    this.setState({ cancelType: '' });
  };

  getTableColumns = () => [
    {
      Header: I18n.t('BEE55' /* Ações */),
      accessor: 'action',
      style: { overflow: 'visible', alignSelf: 'center' },
      filterable: false,
      sortable: false,
      width: 100,
      Cell: (rows) => {
        const row = rows.original;
        const showCancel = this.canCancelSimplifiedDocument(row)
          && !Permissions.checkPermission(ROUTES.P_EXPEDITION_CANCEL_ORDER);
        return (
          <div style={{ textAlign: 'center' }}>
            <button type="button" className="btn btn-default btn-xs">{I18n.t('BEE55' /* Ações */)}</button>
            <UncontrolledButtonDropdown>
              <DropdownToggle color="default" caret className="btn-xs" />
              <DropdownMenu>
                {showCancel && (
                  <DropdownItem onClick={() => this.showCancelDocument(row)}>
                    {I18n.t('BEE99' /* Cancelar */)}
                  </DropdownItem>
                )}
              </DropdownMenu>
            </UncontrolledButtonDropdown>
          </div>
        );
      },
    },
    {
      Header: I18n.t('BEE436' /* Selecionar */),
      accessor: 'simplifiedLoadSelection',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 90,
      filterable: false,
      sortable: false,
      Cell: (rows) => {
        const row = rows.original;
        const selectable = this.isSimplifiedLoadRowSelectable(row);
        return (
          <div style={{ textAlign: 'center' }}>
            <input
              type="checkbox"
              disabled={!selectable}
              checked={!!this.state.simplifiedLoadChecked[row.id]}
              onChange={() => this.singleSimplifiedLoadSelection(row)}
            />
          </div>
        );
      },
    }, {
      Header: I18n.t('BEE443' /* Documento */),
      accessor: 'orderNumber',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 150,
      Filter: this.filterColumn,
      show: true,
    }, {
      Header: I18n.t('BEE145' /* Filial */),
      accessor: 'branchCode',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 80,
      Filter: this.filterColumn,
      show: true,
    }, {
      Header: I18n.t('BEE513' /* Integração */),
      accessor: 'createdAt',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 150,
      filterMethod: (filter, row) => {
        const input = _.lowerCase(filter.value);
        const dateFirstOption = moment(row[filter.id]).format('DD MM YYYY');
        const dateSecondOption = moment(row[filter.id]).format('DDMMYYYY');
        if (_.includes(dateFirstOption, input) || _.includes(dateSecondOption, input)) {
          return true;
        }
      },
      Cell: (row) => (
        <span>
          {' '}
          {moment(row.value).format('L LTS')}
        </span>
      ),
      Filter: this.filterColumn,
      show: true,
    }, {
      Header: I18n.t('BEE4526' /* Carga */),
      accessor: 'loadNumber',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 150,
      Filter: this.filterColumn,
      show: true,
    }, {
      Header: I18n.t('BEE301' /* Transportadora */),
      accessor: 'carrierName',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 250,
      Filter: this.filterColumn,
      show: true,
    }, {
      Header: I18n.t('BEE224' /* Status */),
      accessor: 'status',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 200,
      show: true,
      Cell: (row) => (
        <div style={{ textAlign: 'center' }}>
          <span>{OutboundOrderHelpers.outboundOrderStatus(row.value)}</span>
        </div>
      ),
      filterMethod: (filter, row) => {
        if (parseInt(filter.value, 10) === parseInt(row.status, 10)) {
          return true;
        }
      },
      Filter: ({ onChange }) => (
        <select
          type="text"
          style={{ width: '100%' }}
          onChange={(event) => { onChange(event.target.value); }}
        >
          <option value="">{I18n.t('BEE793' /* Todos */)}</option>
          {OutboundOrderHelpers.outboundOrderStatus().map((elem, index) => (
            <option value={elem.value} key={index}>{elem.label}</option>
          ))}
        </select>
      ),
    }, {
      Header: I18n.t('BEE200' /* Tipo */),
      accessor: 'orderType',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 80,
      Filter: this.filterColumn,
      show: true,
    }, {
      Header: I18n.t('BEE4867' /* Documento Agrupado */),
      accessor: 'groupedOrderNumber',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 200,
      Filter: this.filterColumn,
      show: true,
    }, {
      Header: I18n.t('BEE4535' /* Documentos Vinculados */),
      accessor: 'linkedDocumentsCount',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 180,
      Filter: this.filterColumn,
      show: true,
    }, {
      Header: I18n.t('BEE4868' /* Documentos Esperados */),
      accessor: 'loadDocumentCount',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 180,
      Filter: this.filterColumn,
      show: true,
    }, {
      Header: I18n.t('BEE4488' /* Peso (kg) */),
      accessor: 'totalWeight',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 150,
      Filter: this.filterColumn,
      show: true,
      Cell: (row) => {
        const weightKG = parseFloat(row.value || 0) === 0 ? 0 : FormatHelpers.formatNumber(row.value / 1000, 4);
        return <span>{weightKG}</span>;
      },
    }, {
      Header: I18n.t('BEE1096' /* Pedido cliente */),
      accessor: 'customerOrderCode',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 130,
      Filter: this.filterColumn,
      show: true,
    }, {
      Header: I18n.t('BEE50' /* Cliente */),
      accessor: 'customerName',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 150,
      Filter: this.filterColumn,
      show: true,
    }, {
      Header: I18n.t('BEE182' /* Depósito */),
      accessor: 'depositCode',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 100,
      Filter: this.filterColumn,
      show: true,
    }, {
      Header: I18n.t('BEE402' /* Nota Fiscal */),
      accessor: 'invoiceNumber',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 150,
      Filter: this.filterColumn,
      show: true,
    }, {
      Header: I18n.t('BEE613' /* Urgente */),
      accessor: 'urgent',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 150,
      show: true,
      Cell: (rows) => (
        <div className={{ textAlign: 'center' }}>
          {rows.original.urgent ? I18n.t('BEE172' /* Sim */) : I18n.t('BEE173' /* Não */)}
        </div>
      ),
      Filter: ({ onChange }) => (
        <select
          type="text"
          style={{ width: '100%' }}
          onChange={(event) => { onChange(event.target.value); }}
        >
          <option value="">{I18n.t('BEE793' /* Todos */)}</option>
          <option value>{I18n.t('BEE172' /* Sim */)}</option>
          <option value={false}>{I18n.t('BEE173' /* Não */)}</option>
        </select>
      ),
    }, {
      Header: I18n.t('BEE4115' /* Prioridade */),
      accessor: 'priorityName',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 250,
      Filter: this.filterColumn,
      show: true,
    }, {
      Header: I18n.t('BEE53' /* Cidade */),
      accessor: 'cityName',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 150,
      Filter: this.filterColumn,
      show: true,
    }, {
      Header: I18n.t('BEE1057' /* Entrega */),
      accessor: 'deliveryDate',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 120,
      filterMethod: (filter, row) => {
        const input = _.lowerCase(filter.value);
        const dateFirstOption = moment(row[filter.id]).format('DD MM YYYY');
        const dateSecondOption = moment(row[filter.id]).format('DDMMYYYY');
        if (_.includes(dateFirstOption, input) || _.includes(dateSecondOption, input)) {
          return true;
        }
      },
      Cell: (row) => (
        <span>
          {' '}
          {moment(row.value).format('DD/MM/YYYY')}
        </span>
      ),
      Filter: this.filterColumn,
      show: true,
    }, {
      Header: I18n.t('BEE3197' /* Controle da doca */),
      accessor: 'dockControlId',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 150,
      Filter: this.filterColumn,
      show: true,
    }, {
      Header: I18n.t('BEE907' /* Romaneio */),
      accessor: 'waybillNumber',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 100,
      Filter: this.filterColumn,
      show: true,
    }, {
      Header: I18n.t('BEE2779' /* Restrição Liberada */),
      accessor: 'restrictionPicking',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 150,
      show: true,
      Cell: (rows) => (
        <div>
          <span>
            {(!rows.original.restrictionPicking)
              ? I18n.t('BEE172' /* Sim */) : I18n.t('BEE173' /* Não */)}
          </span>
        </div>
      ),
      Filter: ({ onChange }) => (
        <select
          type="text"
          style={{ width: '100%' }}
          onChange={(event) => { onChange(event.target.value); }}
        >
          <option value="">{I18n.t('BEE793' /* Todos */)}</option>
          <option value={false}>{I18n.t('BEE172' /* Sim */)}</option>
          <option value>{I18n.t('BEE173' /* Não */)}</option>
        </select>
      ),
    }, {
      Header: I18n.t('BEE2780' /* Usuário Liberação */),
      accessor: 'userReleasePickingRestriction.login',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 150,
      Filter: this.filterColumn,
      show: true,
      Cell: (rows) => (
        <div className={{ textAlign: 'center' }}>
          {rows.original.userReleasePickingRestriction ? rows.original.userReleasePickingRestriction.login : ''}
        </div>
      ),
    }, {
      Header: I18n.t('BEE2781' /* Data e Hora liberação */),
      accessor: 'releasePickingRestriction',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 150,
      filterMethod: (filter, row) => {
        const input = _.lowerCase(filter.value);
        const dateFirstOption = moment(row[filter.id]).format('DD MM YYYY');
        const dateSecondOption = moment(row[filter.id]).format('DDMMYYYY');
        if (_.includes(dateFirstOption, input) || _.includes(dateSecondOption, input)) {
          return true;
        }
      },
      Cell: (row) => (
        <span>
          {' '}
          {row.original.releasePickingRestriction
            ? moment(row.releasePickingRestriction).format('L LTS')
            : ''}
        </span>
      ),
      Filter: this.filterColumn,
      show: true,
    },
    {
      Header: I18n.t('BEE3690' /* Retirado por */),
      accessor: 'withdrawalUser',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 150,
      Filter: this.filterColumn,
      show: true,
    },
    {
      Header: I18n.t('BEE444' /* Data de Entrega */),
      accessor: 'withdrawalAt',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 150,
      filterMethod: (filter, row) => {
        const input = _.lowerCase(filter.value);
        const dateFirstOption = moment(row[filter.id]).format('DD MM YYYY');
        const dateSecondOption = moment(row[filter.id]).format('DDMMYYYY');
        if (_.includes(dateFirstOption, input) || _.includes(dateSecondOption, input)) {
          return true;
        }
      },
      Cell: (row) => (
        <span>
          {row.value ? moment(row.value).format('DD/MM/YYYY') : ''}
        </span>
      ),
      Filter: this.filterColumn,
      show: true,
    },
    {
      Header: I18n.t('BEE3691' /* Documento do Recebedor */),
      accessor: 'withdrawnUserDocument',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 200,
      Filter: this.filterColumn,
      show: true,
    },
    {
      Header: I18n.t('BEE135' /* Observação */),
      accessor: 'withdrawnNote',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 150,
      Filter: this.filterColumn,
      show: true,
    },
  ];

  getProductTableColumns = () => [
    {
      Header: I18n.t('BEE55' /* Ações */),
      accessor: 'action',
      style: { overflow: 'visible', alignSelf: 'center' },
      filterable: false,
      sortable: false,
      width: 100,
      Cell: (rows) => {
        const row = rows.original;
        const showCancel = this.canCancelSimplifiedProduct(row)
          && !Permissions.checkPermission(ROUTES.P_EXPEDITION_CANCEL_ITEM_ORDER);
        return (
          <div style={{ textAlign: 'center' }}>
            <button type="button" className="btn btn-default btn-xs">{I18n.t('BEE55' /* Ações */)}</button>
            <UncontrolledButtonDropdown>
              <DropdownToggle color="default" caret className="btn-xs" />
              <DropdownMenu>
                {showCancel && (
                  <DropdownItem onClick={() => this.showCancelProduct(row)}>
                    {I18n.t('BEE99' /* Cancelar */)}
                  </DropdownItem>
                )}
              </DropdownMenu>
            </UncontrolledButtonDropdown>
          </div>
        );
      },
    },
    {
      Header: I18n.t('BEE463' /* Linha */),
      accessor: 'lineNumber',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 100,
      show: true,
    }, {
      Header: I18n.t('BEE225' /* Produto */),
      accessor: 'productCode',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 150,
      show: true,
    }, {
      Header: I18n.t('BEE695' /* Código Complementar */),
      accessor: 'productComplementCode',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 200,
      show: true,
    }, {
      Header: I18n.t('BEE1897' /* Descrição */),
      accessor: 'productName',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 300,
      show: true,
    }, {
      Header: I18n.t('BEE224' /* Status */),
      accessor: 'status',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 200,
      show: true,
      Cell: (row) => (
        <span>{OutboundOrderHelpers.outboundOrderProductStatus(row.value)}</span>
      ),
      filterMethod: (filter, row) => {
        if (parseInt(filter.value, 10) === parseInt(row.status, 10)) {
          return true;
        }
      },
      Filter: ({ onChange }) => (
        <select
          type="text"
          style={{ width: '100%', textAlign: 'center' }}
          onChange={(event) => { onChange(event.target.value); }}
        >
          <option value="">{I18n.t('BEE793' /* Todos */)}</option>
          {OutboundOrderHelpers.outboundOrderProductStatus().map((elem, index) => (
            <option value={elem.value} key={index}>{elem.label}</option>
          ))}
        </select>
      ),
    }, {
      Header: I18n.t('BEE441' /* Quantidade */),
      accessor: 'quantity',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 150,
      show: true,
      type: 'number',
      Cell: (row) => FormatHelpers.formatNumber(row.value || 0, 4),
    }, {
      Header: I18n.t('BEE4377' /* Quantidade Cross-Docking */),
      accessor: 'crossdockingQuantity',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 150,
      show: true,
      type: 'number',
      Cell: (row) => FormatHelpers.formatNumber(row.value || 0, 4),
    }, {
      Header: I18n.t('BEE1579' /* Lance Obrigatório */),
      accessor: 'mandatoryQuantity',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 150,
      show: true,
      type: 'number',
      Cell: (row) => FormatHelpers.formatNumber(row.value || 0, 4),
    }, {
      Header: I18n.t('BEE701' /* Controlar Vencimento */),
      accessor: 'controlExpirationDate',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 180,
      show: true,
      Filter: ({ onChange }) => (
        <select
          type="text"
          style={{ width: '100%' }}
          onChange={(event) => { onChange(event.target.value); }}
        >
          <option key="all" value="">{I18n.t('BEE793' /* Todos */)}</option>
          <option key="true" value>{I18n.t('BEE172' /* Sim */)}</option>
          <option key="false" value={false}>{I18n.t('BEE173' /* Não */)}</option>
        </select>
      ),
      Cell: (row) => (
        <div style={{ textAlign: 'center' }}>
          <span>{row.value ? I18n.t('BEE172' /* Sim */) : I18n.t('BEE173' /* Não */)}</span>
        </div>
      ),
    }, {
      Header: I18n.t('BEE708' /* Tipo de Controle de Estoque */),
      accessor: 'stockControlType',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 200,
      show: true,
      Cell: (row) => (
        <span>{ProductHelpers.stockControlType(row.value)}</span>
      ),
      filterMethod: (filter, row) => {
        if (parseInt(filter.value, 10) === parseInt(row.stockControlType, 10)) {
          return true;
        }
      },
      Filter: ({ onChange }) => (
        <select
          type="text"
          style={{ width: '100%' }}
          onChange={(event) => { onChange(event.target.value); }}
        >
          <option value="">{I18n.t('BEE793' /* Todos */)}</option>
          {ProductHelpers.stockControlType().map((element, index) => (
            <option key={index} value={element.value}>
              {element.label}
            </option>
          ))}
        </select>
      ),
    }, {
      Header: I18n.t('BEE1431' /* Alocado */),
      accessor: 'allocatedQuantity',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 150,
      show: true,
      type: 'number',
      Cell: (row) => FormatHelpers.formatNumber(row.value || 0, 4),
    }, {
      Header: I18n.t('BEE1368' /* Separado */),
      accessor: 'pickedQuantity',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 150,
      show: true,
      type: 'number',
      Cell: (row) => FormatHelpers.formatNumber(row.value || 0, 4),
    }, {
      Header: I18n.t('BEE1721' /* Data Separação */),
      accessor: 'pickedAt',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 150,
      show: true,
      filterMethod: (filter, row) => {
        const input = _.lowerCase(filter.value);
        const dateFirstOption = moment(row[filter.id]).format('DD MM YYYY');
        const dateSecondOption = moment(row[filter.id]).format('DDMMYYYY');
        if (_.includes(dateFirstOption, input) || _.includes(dateSecondOption, input)) {
          return true;
        }
      },
      Cell: (row) => (
        <span>
          {' '}
          {row.value ? moment(row.value).format('L LTS') : ''}
        </span>
      ),
    }, {
      Header: I18n.t('BEE1092' /* Separador */),
      accessor: 'pickedUser',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 150,
      show: true,
    }, {
      Header: I18n.t('BEE445' /* Conferido */),
      accessor: 'checkedQuantity',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 150,
      show: true,
      type: 'number',
      Cell: (row) => FormatHelpers.formatNumber(row.value || 0, 4),
    }, {
      Header: I18n.t('BEE467' /* Data Conferência */),
      accessor: 'checkedAt',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 150,
      show: true,
      filterMethod: (filter, row) => {
        const input = _.lowerCase(filter.value);
        const dateFirstOption = moment(row[filter.id]).format('DD MM YYYY');
        const dateSecondOption = moment(row[filter.id]).format('DDMMYYYY');
        if (_.includes(dateFirstOption, input) || _.includes(dateSecondOption, input)) {
          return true;
        }
      },
      Cell: (row) => (
        <span>
          {' '}
          {row.value ? moment(row.value).format('L LTS') : ''}
        </span>
      ),
    }, {
      Header: I18n.t('BEE805' /* Conferente */),
      accessor: 'checkedUser',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 150,
      show: true,
    }, {
      Header: I18n.t('BEE2112' /* Produto Cliente */),
      accessor: 'customerProductCode',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 150,
      Filter: this.filterColumn,
      show: true,
    },
  ];

  updateColumns = () => {
    this.setState({
      tableColumns: this.getTableColumns(),
      productTableColumns: this.getProductTableColumns(),
    });
  };

  filterColumn = ({ onChange }) => (
    <input
      type="text"
      style={{ width: '100%' }}
      onKeyPress={(event) => {
        if (event.keyCode === 13 || event.which === 13) {
          onChange(event.target.value);
        }
      }}
      onKeyUp={(event) => {
        if (
          event.target.value === ''
          && (event.keyCode === 8 || event.which === 8)
        ) {
          onChange(event.target.value);
        }
      }}
    />
  );

  handleDateApplyEvent = async (event) => {
    const startDate = event[0];
    const endDate = event[1];

    await this.setState({
      startDate,
      endDate,
    });

    this.getOutboundOrders();
  };

  getOutboundOrderProducts = async () => {
    const { selectedOutboundOrder } = this.state;
    try {
      const products = await this.props.getSimplifiedLoadMonitorProducts(
        selectedOutboundOrder.id,
      );
      await this.setState({
        simplifiedOutboundProductsList: products || [],
      });
    } catch (err) {
      const error = err.response && err.response.data && err.response.data.error;

      if (error && error.message) {
        const messageError = (error.details)
          ? `${error.code} - ${error.details} | ${error.message}`
          : error.message;

        addNotification(
          'danger',
          I18n.t('BEE4865' /* Carregamento Simplificado */),
          messageError,
          'top-right',
        );
      } else {
        addNotification(
          'danger',
          I18n.t('BEE4865' /* Carregamento Simplificado */),
          I18n.t('BEE1969' /* Erro ao buscar dados */),
          'top-right',
        );
      }
    }
  };

  getOutboundOrders = async () => {
    const { startDate, endDate, selectedOutboundOrder } = this.state;

    const documents = await this.props.getSimplifiedLoadMonitorDocuments(
      startDate,
      endDate,
    );
    const orderList = documents || [];
    await this.setState({
      simplifiedOutboundOrdersList: orderList,
    });

    const existOrder = (orderList && orderList.length && Object.keys(selectedOutboundOrder).length)
      ? (orderList.find((element) => (element.id === selectedOutboundOrder.id)))
      : {};

    await this.setState({
      selectedOutboundOrder: existOrder || {},
    });

    if (existOrder && Object.keys(existOrder).length) {
      await this.getOutboundOrderProducts();
    } else {
      await this.setState({ simplifiedOutboundProductsList: [] });
    }
  };

  selectedProducts = async (selectedOutboundOrder) => {
    if (!this.state.selectedOutboundOrder || (selectedOutboundOrder && this.state.selectedOutboundOrder
      && this.state.selectedOutboundOrder.id !== selectedOutboundOrder.id)) {
      await this.setState({ selectedOutboundOrder: { ...selectedOutboundOrder } });
      await this.getOutboundOrderProducts();
    }
  };

  render() {
    const {
      simplifiedOutboundOrdersList = [],
      simplifiedOutboundProductsList = [],
      selectedOutboundOrder,
      defaultSorted,
      defaultSortedProducts,
      showGenerateSimplifiedLoadModal,
      showCancelDocumentModal,
      showCancelProductModal,
    } = this.state;

    return (
      <>
        <div>
          <div className="d-flex align-items-center">
            <ol className="breadcrumb float-xl-left">
              <li className="breadcrumb-item">
                <i className="fas fa-home fa-fw m-t-10 m-r-5" />
                {' '}
                {I18n.t('BEE12' /* Início */)}
              </li>
              <li className="breadcrumb-item">
                {I18n.t('BEE1400' /* Movimentação */)}
              </li>
              <li className="breadcrumb-item">{I18n.t('BEE41' /* Expedição */)}</li>
              <li className="breadcrumb-item active">
                {I18n.t('BEE4865' /* Carregamento Simplificado */)}
              </li>
            </ol>
          </div>
          <div className="d-flex align-items-center mb-md-3 mb-2">
            <h1 className="page-header mb-0">
              {I18n.t('BEE4865' /* Carregamento Simplificado */)}
            </h1>
            <WikiHelp wikiPath={ROUTES.OUTBOUND_SIMPLIFIED_LOAD_MONITOR_HELP} />
          </div>
          <Table
            downloadCSV
            panelHeaderProps={{
              onClickReload: this.getOutboundOrders,
            }}
            datePicker={{
              handleDateApplyEvent: this.handleDateApplyEvent,
            }}
            filterable
            data={simplifiedOutboundOrdersList}
            columns={this.state.tableColumns}
            expander
            defaultPageSize={5}
            defaultSorted={defaultSorted}
            defaultFilterMethod={(filter, row) => {
              const input = _.lowerCase(filter.value);
              const value = _.lowerCase(row[filter.id]);
              if (_.includes(value, input)) {
                return true;
              }
            }}
            getTrProps={(state, rowInfo) => {
              if (rowInfo && rowInfo.row) {
                return {
                  onClick: () => {
                    this.selectedProducts(rowInfo.original);
                  },
                  style: {
                    background: selectedOutboundOrder && rowInfo.original.id === selectedOutboundOrder.id
                      ? 'silver'
                      : 'white',
                    cursor: 'pointer',
                  },
                };
              }
              return {};
            }}
            actionButtons={(
              <div className="ml-auto mt-1">
                <button
                  type="button"
                  className="btn btn-success p-5 m-r-5"
                  onClick={() => this.showGenerateSimplifiedLoadModal()}
                >
                  {I18n.t('BEE4866' /* Gerar agrupamento */)}
                </button>
              </div>
            )}
          />
        </div>
        <Table
          downloadCSV
          panelHeaderProps={{
            children: I18n.t('BEE27' /* Produtos */).toUpperCase(),
          }}
          filterable
          data={simplifiedOutboundProductsList}
          columns={this.state.productTableColumns}
          expander
          defaultPageSize={10}
          pageSizeOptions={[5, 10, 15]}
          defaultSorted={defaultSortedProducts}
          defaultFilterMethod={(filter, row) => {
            const input = _.lowerCase(filter.value);
            const value = _.lowerCase(row[filter.id]);
            if (_.includes(value, input)) {
              return true;
            }
          }}
        />
        <UserConfirmationModal
          openModal={this.state.showUserModal}
          confirm={(confirm) => this.userConfirmation(confirm)}
        />
        {showCancelDocumentModal && (
          <SweetAlert
            info
            showCancel
            cancelBtnText={I18n.t('BEE99' /* Cancelar */)}
            confirmBtnText={I18n.t('BEE1849' /* continuar */)}
            confirmBtnBsStyle="primary"
            cancelBtnBsStyle="default"
            title={I18n.t('BEE2943' /* Cancelar Documento */)}
            onConfirm={() => this.setState({
              showUserModal: true,
              showCancelDocumentModal: false,
              cancelType: 'document',
            })}
            onCancel={() => this.setState({ showCancelDocumentModal: false, cancelType: '' })}
          >
            {I18n.t('BEE2946' /* Documento de saída será cancelado! Deseja continuar? */)}
          </SweetAlert>
        )}
        {showCancelProductModal && (
          <SweetAlert
            info
            showCancel
            cancelBtnText={I18n.t('BEE99' /* Cancelar */)}
            confirmBtnText={I18n.t('BEE1849' /* continuar */)}
            confirmBtnBsStyle="primary"
            cancelBtnBsStyle="default"
            title={I18n.t('BEE2944' /* Cancelar Produto */)}
            onConfirm={() => this.setState({
              showUserModal: true,
              showCancelProductModal: false,
              cancelType: 'product',
            })}
            onCancel={() => this.setState({ showCancelProductModal: false, cancelType: '' })}
          >
            {I18n.t('BEE2945' /* Produto será cancelado! Deseja continuar? */)}
          </SweetAlert>
        )}
        {showGenerateSimplifiedLoadModal && (
          <SweetAlert
            info
            showCancel
            cancelBtnText={I18n.t('BEE99' /* Cancelar */)}
            confirmBtnText={I18n.t('BEE172' /* Continuar */)}
            confirmBtnBsStyle="primary"
            cancelBtnBsStyle="default"
            title={I18n.t('BEE4866' /* Gerar agrupamento */)}
            onConfirm={() => this.generateOutboundOrderFromSimplifiedLoad()}
            onCancel={() => this.closeGenerateSimplifiedLoadModal()}
          >
            {I18n.t(
              'BEE4870',
              {
                0: this.getPendingDocumentsCountForSelectedLoad(),
              } /* Existem %{0} documentos pendentes para a carga, deseja prosseguir com o agrupamento? */,
            )}
          </SweetAlert>
        )}
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  getSimplifiedLoadMonitorDocuments: (startDate, endDate) => dispatch(
    getSimplifiedLoadMonitorDocuments(startDate, endDate),
  ),
  getSimplifiedLoadMonitorProducts: (outboundOrderLoadSimplifiedId) => dispatch(
    getSimplifiedLoadMonitorProducts(outboundOrderLoadSimplifiedId),
  ),
  generateOutboundOrderFromSimplifiedLoad: (outboundOrderLoadSimplifiedIds) => dispatch(
    generateOutboundOrderFromSimplifiedLoad(outboundOrderLoadSimplifiedIds),
  ),
  cancelSimplifiedLoadDocument: (outboundOrderLoadSimplifiedId) => dispatch(
    cancelSimplifiedLoadDocument(outboundOrderLoadSimplifiedId),
  ),
  cancelSimplifiedLoadProduct: (outboundOrderLoadSimplifiedProductId) => dispatch(
    cancelSimplifiedLoadProduct(outboundOrderLoadSimplifiedProductId),
  ),
});

export default connect(null, mapDispatchToProps)(withRouter(SimplifiedLoadMonitor));
